export default __webpack_public_path__ + "static/media/after@2x.1b05d11e.png";